import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Layout, Menu } from 'antd';
import styled from 'styled-components';
import SidebarButton from './SidebarButton';

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = (props) => {

  const [collapsed, setCollapsed] = useState(true);
  const [currentSelection, setCurrentSelection] = useState('');

  useEffect(() => {

    const setActiveButton = () => {

      const path = props.$location.path().substring(1, props.$location.path().length);
      const search = props.$location.search();

      switch (path.toLowerCase()) {
        case 'workflow':
          const view = search.view && search.view.toLowerCase();
          if (!view || view === 'tasks') {
            setCurrentSelection('workflow');
          }
          else if (view === 'history') {
            setCurrentSelection('workflow-history');
          }
          else if (view === 'messages') {
            setCurrentSelection('messages');
          }
          break;
        case 'documents':
          const folder = search.folder && search.folder.toLowerCase();
          if (folder === 'favorites') {
            setCurrentSelection('favorites');
          }
          else if (folder === 'recyclebin') {
            setCurrentSelection('recyclebin');
          } else {
            setCurrentSelection(path);
          }
          break;
        default:
          setCurrentSelection(path);
          break;
      }
    }

    // set active button on load
    setActiveButton();

    // listen for route change
    const cleanup = props.$rootScope.$on('$locationChangeStart', function (event, next, current) {
      setActiveButton();
    });

    return () => {
      cleanup();
    };
  }, [props])

  const onCollapse = collapsed => {
    setCollapsed(collapsed);
  };

  const onSelect = e => {
    setTimeout(() => {
      switch (e.key) {
        case 'portal':
          props.$location.url('/portal');
          props.$rootScope.$apply()
          break;
        case 'documents':
          setCurrentSelection(e.key)
          props.$location.url('/documents');
          props.$rootScope.$apply()
          break;
        case 'reports':
          props.$location.url('/reports');
          props.$rootScope.$apply()
          break;
        case 'projects':
          props.$location.url('/projects');
          props.$rootScope.$apply()
          break;
        case 'search':
          props.$location.url('/search');
          props.$rootScope.$apply()
          break;
        case 'saved-search':
          props.$location.url('/saved-search');
          props.$rootScope.$apply()
          break;
        case 'last30Days':
          props.$location.url('/saved-search').search('search=Last%2030%20Days&page=1');
          props.$rootScope.$apply()
          break;
        case 'last30Docs':
          props.$location.url('/saved-search').search('search=Last%2030%20Docs&page=1');
          props.$rootScope.$apply()
          break;
        case 'myCheckedOutDocs':
          props.$location.url('/saved-search').search('search=My%20Checked%20Out%20Docs&page=1');
          props.$rootScope.$apply()
          break;
        case 'myWorkflowTasks':
          props.$location.url('/saved-search').search('search=My%20Workflow%20Tasks&page=1');
          props.$rootScope.$apply()
          break;
        case 'messages':
          setCurrentSelection(e.key)
          props.$location.url('/workflow').search('view=messages');
          props.$rootScope.$apply()
          break;
        case 'workflow':
          props.$location.url('/workflow').search('view=tasks');
          props.$rootScope.$apply()
          break;
        case 'workflow-history':
          props.$location.url('/workflow').search('view=history');
          props.$rootScope.$apply()
          break;
        case 'favorites':
          props.$location.url('/documents').search('folder=favorites');
          props.$rootScope.$apply()
          break;
        case 'recyclebin':
          props.$location.url('/documents').search('folder=recyclebin');
          props.$rootScope.$apply()
          break;
        case 'admin':
          props.$location.url('/admin');
          props.$rootScope.$apply()
          break;
        case 'configuration/users':
          props.$location.url('/configuration/users');
          props.$rootScope.$apply()
          break;
        case 'help':
          window.open('help', '_blank');
          break;
        default:
          break;
      }
    }, 100)
  }

  return (
    <SidebarContainer>
      <Sider
        collapsible width="275"
        collapsed={collapsed}
        onCollapse={onCollapse}
        collapsedWidth={50}
        style={{ backgroundColor: '#f9f9fa', height: '100vh', minHeight: '200px', paddingBottom: '150px' }}
      >
        <>
        {/* <div className="branding"><img alt="Document Locator" className="header-logo" src="images/logo/logo.png" /></div> */}
        <MainMenu>
          <Menu
            selectedKeys={[currentSelection]}
            defaultOpenKeys={!collapsed ? ['sub1'] : []}
            onClick={onSelect}
            mode="inline"
            style={{ padding: '0px', backgroundColor: '#f9f9fa', border: 'none', maxHeight: '400px' }}
          >
            {props.enablePortal &&
              <Menu.Item key="portal" title="Portal">
                <SidebarButton iconType="home" text="Portal" />
              </Menu.Item>
            }
            {props.allowedNodes.includes('documents') &&
              <Menu.Item key="documents" style={{ paddingLeft: '0 !important' }} title="Documents">
                <SidebarButton iconType="file" text="Documents" />
              </Menu.Item>
            }
            {props.enableMessages &&
              <Menu.Item key="messages" title="Messages">
                <SidebarButton iconType="envelope" text="Messages" />
              </Menu.Item>
            }
            {props.allowedNodes.includes('workflow') &&
              <SubMenu
                key="subWorkflow"
                onTitleClick={e => onSelect(e)}
                className="sidebar-submenu"
                title={<SidebarButton iconType="cogs" text="Workflows" />}
              >
                <Menu.Item key="workflow"><SidebarButton iconType="cogs" text="Workflow Tasks" style={{ marginRight: 0 }} /></Menu.Item>
                <Menu.Item key="workflow-history"><SidebarButton iconType="history" text="Workflow History" style={{ marginRight: 0 }} /></Menu.Item>
              </SubMenu>
            }
            {props.allowedNodes.includes('reports') &&
              <Menu.Item key="reports" title="Reports">
                <SidebarButton iconType="chart-bar" text="Reports" />
              </Menu.Item>
            }
            {!props.webViewMode && !props.readOnly && props.allowedNodes.includes('projects') &&
              <Menu.Item key="projects" title="Projects">
                <SidebarButton iconType="project-diagram" text="Projects" />
              </Menu.Item>
            }
            {props.allowedNodes.includes('search') &&
              <SubMenu
                key="subSearch"
                className="sidebar-submenu"
                onTitleClick={e => onSelect(e)}
                title={<SidebarButton iconType="search" text="Searches" />}
              >
                <Menu.Item key="search">
                  <SidebarButton iconType="search" text="Advanced Search" style={{ marginRight: 0 }} />
                </Menu.Item>
                <Menu.Item key="saved-search">
                  <SidebarButton iconType="search-plus" text="Saved Searches" style={{ marginRight: 0 }} />
                </Menu.Item>
                <Menu.Divider></Menu.Divider>
                <Menu.Item key="last30Days">
                  <SidebarButton iconType="history" text="Last 30 Days" style={{ marginRight: 0 }} />
                </Menu.Item>
                <Menu.Item key="last30Docs"><SidebarButton iconType="history" text="Last 30 Docs" style={{ marginRight: 0 }} /></Menu.Item>
                <Menu.Item key="myCheckedOutDocs"><SidebarButton iconType="check" text="My Checked Out Docs" style={{ marginRight: 0 }} /></Menu.Item>
                <Menu.Item key="myWorkflowTasks"><SidebarButton iconType="cogs" text="My Workflow Tasks" style={{ marginRight: 0 }} /></Menu.Item>
              </SubMenu>
            }
            <Menu.Item key="favorites" title="Favorites">
              <SidebarButton iconType="star" text="Favorites" />
            </Menu.Item>
            {!props.webViewMode && !props.readOnly && props.allowedNodes.includes('recycle bin') &&
              <Menu.Item key="recyclebin" title="Recycle Bin">
                <SidebarButton iconType="trash" text="Recycle Bin" />
              </Menu.Item>
            }
            {!props.webViewMode &&
             !props.readOnly &&
              props.allowedNodes.includes('repository configuration') &&
              props.allowedNodes.includes('user manager') &&
              <SubMenu
                key="subConfiguration"
                onTitleClick={e => onSelect(e)}
                className="sidebar-submenu"
                title={<SidebarButton iconType="sliders-h" text="Repository Configuration" />}
              >
                <Menu.Item key="configuration/users">
                  <SidebarButton iconType="user-cog" text="User Manager" style={{ marginRight: 0 }} />
                </Menu.Item>
              </SubMenu>
            }
          </Menu>
        </MainMenu>
        <HelpMenu>
          <Menu
            mode="inline"
            onClick={onSelect}
            selectedKeys={[currentSelection]}
            style={{ position: 'absolute', bottom: '100px', padding: '0px', backgroundColor: '#f9f9fa', border: 'none' }}
            >
            <Menu.Item key="help" title="Help" >
              <SidebarButton iconType="question-circle" text="Help" />
            </Menu.Item>
          </Menu>
        </HelpMenu>
        </>
      </Sider>
    </SidebarContainer>
  );
}

const SidebarContainer = styled.div`
  height: 100%;
  overflow: hidden;
  background-color: #f9f9fa;
  border-right: 1px solid #ddd;
`

const MainMenu = styled.div`
  overflow: hidden auto;
  height: 100%;
`

const HelpMenu = styled.div`

`

const mapStateToProps = state => {
  const { isAdmin, readOnly, allowedNodes } = state.user;
  const { webViewMode, enablePortal, enableMessages } = state.app;
  return { isAdmin, readOnly, webViewMode, enablePortal, enableMessages, allowedNodes };
};

export default connect(mapStateToProps)(Sidebar);